import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: ${(props) => (props.width ? props.width + 'px' : '44px')};
  height: ${(props) => (props.height ? props.height + 'px' : '44px')};
`;

export const Image = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  width: ${(props) => (props.width ? props.width + 'px' : '44px')};
  height: ${(props) => (props.height ? props.height + 'px' : '44px')};
  background-color: #46beaf;
  border-radius: ${(props) =>
    props.borderRadius ? props.borderRadius + 'px' : '8px'};
`;
